import type { ShowingRequestResult } from '@alexanderathoodly/data-models'
import { apiClient } from '~/utils/requests'
import type { AuthQueryFactory } from './useauthquery'

export const showingRequestsQuery: AuthQueryFactory<
	[],
	ShowingRequestResult[],
	ShowingRequestResult[],
	['showing_requests']
> = () => {
	return {
		queryKey: ['showing_requests'],
		queryFn: async ({ jwtToken }) => {
			return await apiClient.getShowingRequests(jwtToken)
		},
		staleTime: 15 * 60 * 1000, // Valid 15 minutes
	}
}
